import EmptySec from "./EmptySec";
import FooterSec from "./FooterSec";
import HowIWork from "./HowIWorkSec";
import MyTerms from "./MyTerms";
import ReviewSec from "./ReviewSec";
import ToolsSec from "./ToolsSec";

export default function Segment5(){
    return(
    <div className="seg4">
        <MyTerms/>
        <FooterSec/>
    </div>
    )
}